import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SuggestionsHeader from "./SuggestionsHeader";
import RouteTokenSwitch from "../RouteTokenSwitch";
import RouteSortingMenu from "../RouteSortingMenu";
const TitleRow = ({ item, hideTokenSwitch }) => {
    if (item.text.toLowerCase().includes("suggestions")) {
        return _jsx(SuggestionsHeader, {});
    }
    return (_jsxs("div", { className: "text-primary-text-tertiary text-base font-normal leading-5 pl-1 sticky top-0 z-50 flex items-baseline", children: [_jsxs("div", { className: "flex items-center gap-1", children: [_jsx("p", { children: item.text }), item.text.toLowerCase().includes("all") &&
                        _jsx(RouteSortingMenu, {})] }), item.text.toLowerCase().includes("all") && !hideTokenSwitch &&
                _jsx("div", { className: "relative ml-auto flex items-center gap-2", children: _jsx(RouteTokenSwitch, {}) })] }));
};
export default TitleRow;
